import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CpfCnpjValidator } from 'ngx-cpf-cnpj';
import { AbstractCrudComponent } from '../../../component/abstract-crud.component';
import { ErrorDialogComponent } from '../../../dialogs/error-dialog/error-dialog.component';
import { PacienteDTO } from '../../../dtos/paciente-dto';
import { TipoMarcacaoEnum } from '../../../enums/tipo-marcacao-enum';
import { PacienteService } from '../../../paciente/paciente.service';
import { Util } from '../../../util/util';
import { CustomDateValidator } from '../../../validators/custom-date-validator';

@Component({
  selector: 'app-procurar-paciente',
  templateUrl: './procurar-paciente.component.html',
  styleUrls: ['./procurar-paciente.component.css']
})
export class ProcurarPacienteComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['nome', 'dataNascimento', 'cpf', 'foneResidencial', 'foneCelular', 'details'];

  formularioDeReenvioComprovanteProcurarPaciente: FormGroup;

  filtroPaciente: PacienteDTO = new PacienteDTO();

  tipoMarcacao: TipoMarcacaoEnum;

  constructor(private pacienteService: PacienteService, router: Router, dialog: MatDialog,
    private formBuilder: FormBuilder) {

    super(router, dialog);

    this.tipoMarcacao = history.state.tipoMarcacao;

    this.formularioDeReenvioComprovanteProcurarPaciente = this.formBuilder.group({
      nome: ['', [Validators.minLength(3)]],
      cpf: ['', [CpfCnpjValidator.validate]],
      dataNascimento: [''],
    }, {
      validator: CustomDateValidator('dataNascimento')
    });
  }

  ngOnInit() {

    if (this.tipoMarcacao) {

      this.filtroPaciente = history.state.filtroPaciente;

      if (this.filtroPaciente && (this.filtroPaciente.nome || this.filtroPaciente.cpf || this.filtroPaciente.dataNascimento)) {

        this.formularioDeReenvioComprovanteProcurarPaciente.setValue(this.filtroPaciente);

        this.reloadData(this.filtroPaciente);
      }
      super.ngOnInit();

    } else {

      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Tipo de marcação não encontrado.'
        }
      });
    }
  }

  reloadData(pacienteDTO: PacienteDTO) {

    if (!pacienteDTO.nome && !pacienteDTO.cpf && !pacienteDTO.dataNascimento) {

      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Selecione pelo menos um campo de filtro!'
        }
      });

    } else {

      this.pacienteService.procurarPacienteEDependentePorFiltroComProjecao(pacienteDTO)
        .subscribe(data => {
          // console.log(data)
          this.data = data;
          this.configurarDataSource();
        }, error => {
          console.log(error);
        });

    }
  }

  onSubmit() {
    this.filtroPaciente = this.formularioDeReenvioComprovanteProcurarPaciente.value;

    this.reloadData(this.filtroPaciente);
  }

  reenviarComprovante(pacienteSelecionado: PacienteDTO) {

    const filtroPaciente: PacienteDTO = this.formularioDeReenvioComprovanteProcurarPaciente.value;
    let paginaReenvioComprovante: string = '';
    let temTipoMarcacao: boolean = false;

    if (this.tipoMarcacao == TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA) {
      temTipoMarcacao = true;
      paginaReenvioComprovante = 'selecionarMarcacaoConsultaParaReenvioDeComprovante';
    } else if (this.tipoMarcacao == TipoMarcacaoEnum.TIPO_MARCACAO_EXAME) {
      temTipoMarcacao = true;
      paginaReenvioComprovante = 'selecionarMarcacaoProcedimentoParaReenvioComprovante';
    } else {
      temTipoMarcacao = false;
      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Não foi possível reenviar o comprovante. Tipo de Marcação não encontrado!'
        }
      });
    }

    if (temTipoMarcacao) {
      this.router.navigate([paginaReenvioComprovante], {
        state: {
          filtroPaciente: filtroPaciente,
          pacienteSelecionado: pacienteSelecionado,
          tipoMarcacao: history.state.tipoMarcacao,
        }
      });
    }
  }

  pattern = Util.pattern;

}
